module.exports = __webpack_public_path__ + "static/forecast/weather/nightmodsnow-1ea76922abcd72cf6018a484829e985e.svg";